<template>
  <div class="modal-url-pattern-setting">
    <img class="close-img" src="/../img/ic-m-close.svg" @click="onClickClose" />
    <div class="slot1">
      <span>{{ $t("url_pattern_setting.title") }}</span>
      <div class="date_guide">
        <span v-if="updateDate"
          >{{ $t("url_pattern_setting.updated") }} {{ updateDate }}</span
        >
        <div class="guide">
          <a href="http://imqa.io/documents" target="_blank">
            <img src="/../img/icon-guide-pg.svg" />
            <span>{{ $t("url_pattern_setting.guide") }}</span>
          </a>
        </div>
      </div>
    </div>
    <span class="seperate-line"></span>
    <div class="slot2">
      <p v-html="$t('url_pattern_setting.sub_title')"></p>
    </div>
    <div class="slot3">
      <div class="content-box">
        <div class="dragndrop">
          <div class="head">
            <span>{{ $t("url_pattern_setting.head.priority") }}</span>
            <span>{{ $t("url_pattern_setting.head.pattern") }}</span>
            <span>{{ $t("url_pattern_setting.head.manage") }}</span>
          </div>
          <draggable
            v-if="patterns.length > 0"
            @mousedown="onTransion()"
            v-model="patterns"
            item-key="pattern"
            @change="setPriority($event)"
            draggable=".item"
            :componentData="componentData"
            :animation="100"
            @start="dragging = true"
            @end="dragging = false"
          >
            <template #item="{ element }">
              <div class="item">
                <span class="priarity" scope="row">
                  <img src="/img/icon-list.svg" />
                  <span>{{ element.priority }}</span>
                </span>
                <div>{{ element.pattern }}</div>
                <span>
                  <a
                    class="pattern-delete-icon"
                    @click.capture="deletePattern(element)"
                  ></a>
                </span>
              </div>
            </template>
          </draggable>
          <div class="no-data" v-else>
            <div class="no-data-inner">
              {{ $t("common.no_data") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="seperate-line"></span>
    <div class="slot4">
      <div class="tooltip">
        <span>{{ $t("url_pattern_setting.url_pattern_tooltip.title") }}</span>
        <span class="title_question">
          <div class="tooltip_text">
            <p>{{ $t("url_pattern_setting.url_pattern_tooltip.title") }}</p>
            <p>{{ $t("url_pattern_setting.url_pattern_tooltip.text1") }}</p>
            <p>{{ $t("url_pattern_setting.url_pattern_tooltip.text2") }}</p>
            <p v-html="$t('url_pattern_setting.url_pattern_tooltip.text3')"></p>
            <p v-html="$t('url_pattern_setting.url_pattern_tooltip.text4')"></p>
            <p v-html="$t('url_pattern_setting.url_pattern_tooltip.text5')"></p>
          </div>
        </span>
      </div>
      <div class="div_path">
        <input
          type="text"
          class="input_path"
          :placeholder="$t('url_pattern_setting.placeholder.path')"
          v-model="pathPattern"
          @keydown="isChanged = true"
        />
      </div>
      <div class="div_query">
        <input
          type="text"
          class="input_query"
          :placeholder="$t('url_pattern_setting.placeholder.query')"
          v-model="queryPattern"
          @keydown="isChanged = true"
        />
      </div>
      <a class="pattern-add-icon" @click="addPattern"></a>
    </div>
    <div class="slot5">
      <button class="submit-btn" type="button" @click="onSave">
        {{ $t("common.save") }}
      </button>
      <button class="cancel-btn" type="button" @click="onClickClose">
        {{ $t("common.cancel") }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";

export default {
  name: "modal-cross-domain-setting",
  components: {
    draggable,
  },
  data() {
    return {
      isChanged: false,
      patterns: [],
      pathPattern: "",
      queryPattern: "",
      updateDate: null,
      dragging: false,
      componentData: {
        props: {
          type: "transition",
          name: "flip-list",
        },
      },
      projectId: null,
    };
  },
  computed: {},
  created() {
    this.projectId = this.$store.state.modalProps.pId;

    this.getProjectUrlPatterns();
  },
  methods: {
    onClickClose() {
      if (this.isChanged) {
        const confirm_result = confirm(
          this.$t("app_version_management.alert_close")
        );
        if (!confirm_result) {
          return;
        }
      }
      this.isChanged = false;
      this.$emit("closeEvent", true);
    },
    formatDate(date) {
      const dateObj = new Date(date);
      // dateObj.setHours(dateObj.getHours() + this.$store.state.timezone)

      const year = dateObj.getFullYear();
      const month =
        dateObj.getMonth() >= 10
          ? dateObj.getMonth() + 1
          : "0" + (dateObj.getMonth() + 1);
      const day =
        dateObj.getDate() >= 10 ? dateObj.getDate() : "0" + dateObj.getDate();
      const hour =
        dateObj.getHours() >= 10
          ? dateObj.getHours()
          : "0" + dateObj.getHours();
      const min =
        dateObj.getMinutes() >= 10
          ? dateObj.getMinutes()
          : "0" + dateObj.getMinutes();

      return `${year}-${month}-${day} ${hour}:${min}`;
    },
    getProjectUrlPatterns() {
      axios.get(`/api/wpm/v3/webview/${this.projectId}/url_pattern/list`).then(res => {
        const dataList = res.data.pattern;
        if (dataList.length > 0) {
          this.updateDate = this.formatDate(dataList[0].update_date);
          this.patterns = dataList.sort((a, b) => {
            return a.priority - b.priority
          }).map((data, idx) => {
            return {
              ...data,
              pattern: data.url_path_pattern + data.url_query_pattern,
              priority: idx + 1
            }
          })
        }
      })
    },
    deletePatternConfirm(pattern) {
      return confirm(`${pattern}를 URL 패턴 목록에서 제거하시겠습니까?`);
    },
    deletePattern(e) {
      if (this.deletePatternConfirm(e.pattern)) {
        const body = {
          url_path_pattern: e.url_path_pattern,
          url_query_pattern: e.url_query_pattern,
        };

        axios
          .post(`/api/wpm/v3/webview/${this.projectId}/url_pattern/delete`, {
            ...body,
          })
          .then((res) => {
            this.getProjectUrlPatterns();
          });
      }
    },
    setPriority(event) {
      this.isChanged = true;
      if (event.moved.element.priority === null) return;
      let count = 0;
      let temp_index = 0;
      let temp_priority = null;
      let e_priority = event.moved.element.priority;
      let start_value = 0;
      let end_value = 0;
      let oper_value = 1;

      if (event.moved.newIndex < event.moved.oldIndex) {
        // 낮은 순위 -> 높은 순위 (ex: 3 -> 1)
        temp_index = event.moved.newIndex + 1;
        start_value = event.moved.newIndex + 1;
        end_value = event.moved.oldIndex;
        oper_value = 1;
      } else {
        // 높은 순위 -> 낮은 순위 (ex: 1 -> 3)
        temp_index = event.moved.newIndex - 1;
        start_value = event.moved.oldIndex;
        end_value = event.moved.newIndex - 1;
        oper_value = -1;
      }
      temp_priority = this.patterns[temp_index].priority;
      for (let i = start_value; i <= end_value; i++) {
        if (this.patterns[i].priority === null) continue;
        count += 1;
        this.patterns[i].priority += oper_value;
      }
      if (temp_priority === null) {
        this.patterns[event.moved.newIndex].priority =
          e_priority - oper_value * count;
      } else {
        this.patterns[event.moved.newIndex].priority = temp_priority;
      }
    },
    setAlert(text) {
      alert(`${text}`);
    },
    patternValidation(path, query) {
      // Path 값이 있는지 확인
      if (!path && !query) {
        this.setAlert("URL 패턴을 입력해주세요.");
        return false;
      }

      path = "/" + path;

      // Path 형식인지 확인
      if (!this.checkPath(path)) {
        this.setAlert("URL 형식에 맞게 입력해주세요.");
        return false;
      }
      // Query 형식인지 확인
      if (query && !this.checkQuery(query)) {
        this.setAlert("URL 형식에 맞게 입력해주세요.");
        return false;
      }
      //Query Key 중복 확인, =뒤에만 중괄호 가능
      if (query && !this.checkQueryKeyDuplicated(query)) {
        this.setAlert("쿼리 파라미터는 '키=값' 형식으로 입려되어야 합니다.");
        return false;
      }

      return true;
    },
    checkPath(path) {
      const pattern = /^[a-zA-Z0-9_-{}/.]*$/;
      return pattern.test(path);
    },
    checkQuery(query) {
      const pattern =
        /^[a-zA-Z0-9_-]+=[a-zA-Z0-9_-{}]+(&[a-zA-Z0-9_-]+=[a-zA-Z0-9_-{}]+)*$/;
      return pattern.test(query);
    },
    checkQueryKeyDuplicated(query) {
      const queryKeysArray = this.getQueryKeys(query);
      const queryKeysSet = new Set([...queryKeysArray]);

      if (queryKeysArray.length !== queryKeysSet.size) return false;
      return true;
    },
    getQueryKeys(query) {
      const searchParams = new URLSearchParams(query);
      const keys = [];

      for (const key of searchParams.keys()) {
        keys.push(key);
      }

      return keys;
    },
    checkPatternDuplicated(pattern) {
      return this.patterns.find((p) => p.pattern === pattern);
    },
    addPattern() {
      if (!this.patternValidation(this.pathPattern, this.queryPattern)) return;
      const pattern = this.queryPattern
        ? `/${this.pathPattern}?${this.queryPattern}`
        : `/${this.pathPattern}`;

      if (this.checkPatternDuplicated(pattern)) {
        this.setAlert("이미 추가된 URL 패턴 입니다.");
        return;
      }
      this.patterns.push({
        url_path_pattern: `/${this.pathPattern}`,
        url_query_pattern: this.queryPattern ? `?${this.queryPattern}` : "",
        priority: this.patterns.length + 1,
        pattern: pattern,
      });

      this.pathPattern = "";
      this.queryPattern = "";
    },
    onSave() {
      if (this.pathPattern || this.queryPattern) {
        this.setAlert(
          "입력하신 패턴을 우측 '+'버튼을 눌러 목록에 추가해주세요"
        );
        return;
      }
      const list = this.patterns.map((pat) => {
        return {
          url_path_pattern: pat.url_path_pattern,
          url_query_pattern: pat.url_query_pattern,
          priority: pat.priority,
        };
      });

      axios
        .post(`/api/wpm/v3/webview/${this.projectId}/url_pattern/list`, {
          list,
        })
        .then(() => {
          this.getProjectUrlPatterns();
          this.setAlert("설정이 완료되었습니다.");
          this.isChanged = false;
        })
        .catch(() => {
          this.setAlert(this.$t("common.save_fail"));
        });
    },
    onTransion() {
      document.querySelector(".dragndrop").classList.add("onMove");
    },
    onNotTransion() {
      document.querySelector(".dragndrop").classList.remove("onMove");
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin input-text {
  width: 100%;
  height: 43px;
  border-radius: 10px;
  border: solid 1px #e0e0e0;
  background-color: #ffffff;
  padding: 12px 10px 12px 10px;
  display: block;
  font-size: 13px;
  box-sizing: border-box;
  outline: none;
}
.modal-url-pattern-setting {
  margin: auto;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.54);
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  z-index: 4;
  box-sizing: border-box;
  width: 687px;
  padding: 11.5px 24px 33px 24px;
  .slot1 {
    width: 100%;
    display: flex;
    justify-content: space-between;
    & > span {
      font-size: 15px;
      color: #2e2e2e;
      font-weight: 700;
    }
    .date_guide {
      display: flex;
      & > span {
        font-size: 12px;
        color: #847f7c;
        margin-right: 11px;
      }
      .guide {
        a {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          text-decoration: none;
          color: #565555;
          img {
            margin-right: 11px;
            margin-top: 3px;
          }
          span {
            font-size: 12px;
          }
        }
      }
    }
  }
  .slot2 {
    width: 100%;
    padding-top: 14px;
    & > p {
      font-size: 13px;
      color: #848484;
    }
  }
  .slot3 {
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: space-between;
    padding-top: 15px;

    .content-box {
      width: 100%;
      height: calc(100%);
      overflow-y: auto;
      .dragndrop {
        height: calc(100% - 59px);

        > span {
          display: block;
          overflow-y: auto;
          height: 100%;
        }

        .head {
          display: flex;
          flex-flow: row nowrap;
          height: 32px;
          border-top: solid 1px #e5e5e5;
          border-bottom: solid 1px #e5e5e5;
          > span {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            justify-content: center;
            width: 75px;
            font-family: "NotoSans", "Roboto";
            font-size: 12px;
            font-weight: bold;
            color: #626262;
          }
          > span:nth-child(2) {
            flex: 1;
            width: 100%;
          }
        }
        .item {
          display: flex;
          flex-flow: row nowrap;
          box-sizing: border-box;
          padding: 5px 0px;
          cursor: move;
          min-height: 38px;

          & > span,
          & > div {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            justify-content: center;
            width: 75px;
            color: #000;
            text-align: center;
            font-size: 12px;
          }
          & > div {
            justify-content: left;
          }
          & > span:first-child {
            span {
              width: 15px;
              padding-left: 10px;
            }
          }
          & > span:nth-child(2) {
            flex: 1;
            width: 100%;
            text-align: left;
          }
          & > div {
            flex: 1;
            width: 100%;
            text-align: left;
          }
          &.sortable-drag {
            border-bottom: solid 1px #4d41f2;
            background-color: #f9f8ff;
            opacity: 1 !important;
          }
          & + .item {
            border-top: 1px solid #efefef;
          }
          &:last-child {
            border-bottom: 1px solid #efefef;
          }
        }
        .no-data-inner {
          padding-top: 10px;
          font-size: 11px;
          text-align: center;
          color: #9e9e9e;
        }
      }
    }
  }
  .slot4 {
    .div_path {
      position: relative;
      width: 40%;
      &::before {
        content: "/";
        font-size: 13px;
        position: absolute;
        left: 11px;
        top: 8px;
      }
    }
    .div_query {
      position: relative;
      width: 40%;
      &::before {
        content: "?";
        font-size: 13px;
        position: absolute;
        left: 11px;
        top: 8px;
      }
    }
    input {
      @include input-text;
      height: 32px;
      padding-left: 20px;
    }
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-top: 15px;
    align-items: center;
    .tooltip {
      .title_question {
        display: inline-block;
        position: relative;
        top: 1px;
        width: 14px;
        height: 14px;
        margin-left: 3px;
        vertical-align: middle;
        background: url(@/assets/img/ico-question.svg) no-repeat;
      }
      .title_question:hover {
        cursor: pointer;
      }
      .title_question:hover .tooltip_text {
        visibility: visible;
      }
      .title_question .tooltip_text {
        position: absolute;
        background: #000000;
        top: -270px;
        left: -68px;
        visibility: hidden;
        width: max-content;
        padding: 9px;
        z-index: 2;
        word-wrap: break-word;
        opacity: 0.8;
        border-radius: 2px;
        font-size: 11px;
        color: #ffffff;
      }
      & > span {
        color: #2e2e2e;
        font-size: 13px;
        font-weight: 700;
      }
    }
  }
  .slot5 {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 23px;
  }
}
.seperate-line {
  width: 100%;
  height: 1px;
  border: solid 0.5px #e2e2e2;
  margin-top: 8px;
  box-sizing: border-box;
}
@mixin btn-text {
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  outline: none;
  border: none;
}
.submit-btn {
  @include btn-text;
  float: left;
  margin-right: 11px;
  width: 120px;
  height: 35px;
  border: 1px solid #4639de;
  background-color: #ffffff;
  color: #4639de;
  cursor: pointer;
}
.cancel-btn {
  @include btn-text;
  width: 120px;
  height: 35px;
  border: 1px solid #bebebe;
  background-color: #ffffff;
  color: #bebebe;
  cursor: pointer;
}
.close-img {
  position: absolute;
  top: 0px;
  cursor: pointer;
  left: 697px;
}
.color_blue {
  color: #4639de;
}
.guide {
  a {
    box-sizing: border-box;
    text-decoration: none;
    color: #565555;
    span {
      font-size: 12px;
    }
  }
}
.pattern-add-icon {
  cursor: pointer;
  background: url(@/assets/img/btn-plus.svg) no-repeat center;
  width: 20px;
  height: 20px;
  padding-right: 1px;
  padding-bottom: 1px;
  &:hover {
    background: url(@/assets/img/btn-plus.svg) no-repeat center;
    background-repeat: no-repeat;
  }
}
.pattern-delete-icon {
  cursor: pointer;
  display: block;
  float: right;
  width: 20px;
  height: 20px;
  background: url(@/assets/img/team-member-minus.svg);
  &:hover {
    //background: url(/img/team-member-minus-on.svg);
  }
}
</style>
